import { FCX } from "@datassential/platform-ui-lib";
import { sanitizeUrl } from "@helpers";
import { ID } from "@models";
import { TopPerformingChain } from "@apiHooks/useCategoryProfileBrandPerformance";
import CategoryProfileSubtitle from "@pages/CategoryProfile/components/CategoryProfileSubtitle/CategoryProfileSubtitle";
import TopPerformingChainRow from "../TopPerformingChainRow/TopPerformingChainRow";
import "./TopPerformingChains.styles.scss";

function buildBpChainLink(bpUrl: string, chainId: ID | null): string | null {
    if (!bpUrl || chainId === null) return null;
    return sanitizeUrl(`${bpUrl}/restaurants/chain/${chainId}/overview`);
}

interface Props {
    chains: TopPerformingChain[];
    categoryNames: string[];
    bpUrl: string;
}

const TopPerformingChains: FCX<Props> = ({ chains, categoryNames, bpUrl }) => {
    return (
        <div className="TopPerformingChains">
            <div>
                <CategoryProfileSubtitle>
                    Top Performing Chains
                </CategoryProfileSubtitle>
                <span className="TopPerformingChains__categories">
                    {`% rating "best in class" or "above average" for ${categoryNames.join(", ")}`}
                </span>
            </div>

            <div className="TopPerformingChains__columns">
                {chains.map(chain => (
                    <TopPerformingChainRow
                        key={chain.rank}
                        chain={chain}
                        link={buildBpChainLink(bpUrl, chain.id)}
                    />
                ))}
            </div>
        </div>
    );
};

export default TopPerformingChains;
